<!--
 * @Author: xuesong
 * @Date: 2021-04-19 10:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-11 18:20:16
 * @Description: 
-->
<template>
  <div>
    <div
      @contextmenu="openMenu($event, rightMenuData)"
      class="text-im"
      :style="{backgroundColor: bgColor,color: color}">
      <div v-html="replaceEmoji(data.text)" style='white-space:pre-wrap;'>{{ replaceEmoji(data.text) }}</div>
    </div>
    <!-- 自定义右键菜单容器 -->
    <ul
      v-show="rightMenuOpt.visible"
      ref="rightMenu"
      class="right-menu"
      :style="{
        left: rightMenuOpt.left+'px',
        top: rightMenuOpt.top+'px',
        rightMenuOpt: rightMenuOpt.opacity}">
      <!-- 菜单内容通过插槽传入 并注入关闭菜单方法 每个方法执行后记得执行关闭事件 -->
      <slot name="rightMenu" :opt="{closeMenu}"></slot>
    </ul>
  </div>
  
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    bgColor: {
      type: String,
      default: "#F5F5F5"
    },
    color: {
      type: String,
      default: "#333"
    },
    showRightMenu: { // 是否开启自定义右键菜单
      type: Function
    },
    rightMenuData: { // 自定义菜单需要的一些参数
      type: Object,
      default: () => {}
    }
  },
  watch: {
    "rightMenuOpt.visible"(val) {
      if (val) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  data() {
    return {
      emojiList: this.$commen.emojiList,
      doctorImg: process.env.VUE_APP_OSS_URL, //医生历史图片接受路径
      rightMenuOpt: { // 右键菜单配置
        visible: false,
        left: 0,
        top: 0,
        opacity: 0
      }
    };
  },
  methods: {
    // 打开右键菜单
    openMenu(ev) {
      // 检查开启右键菜单的检查方法是否为函数
      if (Object.prototype.toString.call(this.showRightMenu) !== '[object Function]') return false
      // 检查是否可以开启右键菜单
      if (!(this.showRightMenu(this.rightMenuData))) return false
      const e = ev || window.event;
      const menuEl = this.$refs.rightMenu
      
      this.preDef(e) // 阻止默认行为 关闭默认的右键弹框
      const { pageX, pageY } = e // 获取鼠标定位 并赋值给自定义的右键菜单并打开
      this.rightMenuOpt.left = pageX
      this.rightMenuOpt.top = pageY
      this.rightMenuOpt.visible = true
      this.$nextTick(() => {
        this.rightMenuOpt.top = pageY - menuEl.clientHeight
        this.rightMenuOpt.opacity = 1
      })
    },
    closeMenu() {
      this.rightMenuOpt.visible = false
    },
    // 阻止默认行为
    preDef(e){
      if(e.preventDefault){
          e.preventDefault();
      }else{
          window.event.returnValue = false;
      }
    },
    //替换表情符号为图片
    replaceEmoji(str) {
      let replacedStr = str.replace(/\[([^(\]|\[)]*)\]/g, (item, index) => {
        for (let i = 0; i < this.emojiList.length; i++) {
          let row = this.emojiList[i];
          if (row.alt == item) {
            //在线表情路径，图文混排必须使用网络路径，请上传一份表情到你的服务器后再替换此路径
            //比如你上传服务器后，你的100.gif路径为https://www.xxx.com/emoji/100.gif 则替换onlinePath填写为https://www.xxx.com/emoji/

            let onlinePath = this.doctorImg + "face/" + row.url;
            let imgstr =
              '<img style="width:25px;height: 25px" src="' + onlinePath + '">';
            return imgstr;
          }
        }
      });
      return replacedStr;
    }
  }
};
</script>

<style scoped lang="less">
.text-im {
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  padding: 10px;
  div {
    line-height: 20px;
  }
}
.right-menu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.right-menu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.right-menu li:hover {
  background: #eee;
}
</style>